import React from "react";

const DataDeletionInstructions = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-12 text-gray-700">
      <h1 className="text-3xl font-bold text-black mb-6">
        DATA DELETION INSTRUCTIONS
      </h1>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        Overview
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        At <strong>Param Life Wellness Private Limited</strong> (“Param Life”, “we”, “us”, or “our”), 
        we respect your privacy and provide users the ability to request deletion of their personal data in accordance with applicable data protection laws.
      </p>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        If you have used our app or website and wish to delete your data, please follow the steps outlined below. Once your request is verified, 
        we will remove your personal data from our systems, except where retention is required by law.
      </p>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        How to Request Data Deletion
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        You can request deletion of your personal data by any of the following methods:
      </p>
      <ul className="list-disc ml-6 text-gray-600 md:text-md mt-2 text-sm">
        <li>
          Send an email to our support team at{" "}
          <a
            href="mailto:mitra@param.life"
            className="text-primary hover:underline"
          >
            mitra@param.life
          </a>{" "}
          with the subject line <strong>“Data Deletion Request”</strong>.
        </li>
        <li>
          Include in your email:
          <ul className="list-decimal ml-6 mt-1">
            <li>Your registered name and email address.</li>
            <li>The reason for your deletion request (optional).</li>
            <li>Any additional identifying information if needed for account verification.</li>
          </ul>
        </li>
      </ul>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        Processing Timeline
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        Once your request is received and verified, we will delete your personal data within 
        <strong> 7 working days</strong>. You will receive a confirmation email once the deletion process is complete.
      </p>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        What Data Will Be Deleted
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        When you request data deletion, we will permanently remove all personally identifiable information such as:
      </p>
      <ul className="list-disc ml-6 text-gray-600 md:text-md mt-2 text-sm">
        <li>Your account details and profile information.</li>
        <li>Any stored preferences or activity data linked to your account.</li>
        <li>Any associated data from third-party logins (e.g., Google, Facebook).</li>
      </ul>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        Data Retention Exceptions
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        Certain minimal data may be retained if required by law or for legitimate business purposes such as fraud prevention, legal compliance, or dispute resolution. 
        This retained data will be handled in compliance with our{" "}
        <a href="/privacy-policy" className="text-primary hover:underline">
          Privacy Policy
        </a>.
      </p>

      <h2 className="text-lg md:text-xl font-semibold text-secondary mt-6">
        Contact Information
      </h2>
      <p className="text-gray-600 md:text-md mt-2 text-sm">
        If you have any questions or concerns about data deletion, please contact us at:{" "}
        <a
          href="mailto:mitra@param.life"
          className="text-primary hover:underline"
        >
          mitra@param.life
        </a>
      </p>
    </div>
  );
};

export default DataDeletionInstructions;
